import {Component, Input, OnInit} from "@angular/core";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {CloudflareService} from "../../../services/cloudflare.service";
import * as fromStore from '../../../../../../store';
import {Store} from "@ngrx/store";
import {DbModalService} from "../../../../../../modules/modal/modal";
import {filter, first, takeUntil} from "rxjs/operators";
import {TypeUtils} from "../../../../../../shared/utils/type-utils";
import {Subject} from "rxjs";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'db-verify-hostname',
    templateUrl: './verify-hostname.component.html',
    styleUrls: ['./verify-hostname.component.scss'],
    standalone: false
})
export class VerifyHostnameComponent implements OnInit {

  @Input() serverType: string;
  @Input() dnsRecord: any;
  @Input() websiteId: number;
  @Input() websiteUrl: string;

  public isMobile: boolean;
  public showVerify: boolean;
  public loading: boolean = true;
  public isCopiedCodes: any = [];
  public isCopiedHostNames: any = [];
  public isCopiedAHostNames: any = [];
  public dnsRecordsForCopy: any[] = [];
  public cfRecordsForCopy: any[] = [];
  public cdnIsLive: boolean;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _dbModalService: DbModalService,
    private _activeModal: DbActiveModal,
    private _cloudflareService: CloudflareService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
    this._getDnsData();
    this.isMobile = window.innerWidth <= 991;
  }

  private _getDnsData(): void {
    this._store.select(fromStore.getCloudflareData(this.websiteId))
      .pipe(
        takeUntil(this._destroyStream$),
        filter((data) => !TypeUtils.isEmpty(data)),
        first()
      ).subscribe(data => {
        if (!TypeUtils.isNull(data) && !TypeUtils.isEmpty(data)) {
          this.loading = false;
          this.cdnIsLive = data && data.cfStatus !== 'pending';
          !!this.showVerify && this.resize([344, 700]);
          !!this.cdnIsLive && this.resize([null, 700]);
          data && data.ownershipVerificationRecords && this.dnsRecordsForCopy.push(data.ownershipVerificationRecords);
          data && data.sslVerificationRecords && (this.dnsRecordsForCopy = [...this.dnsRecordsForCopy, ...data.sslVerificationRecords]);
          this.cfRecordsForCopy = data && data.cfRecords;
        }
      });
  }

  public resize(size: [number, number]): void {
    this._activeModal.resize(...size);
  }

  public confirm(): void {
    if (this.cdnIsLive || this.showVerify) {
      this.sendEvent('Dashboard Action', 'I’ve updated DNS button click');
      this._router.navigate([`websites/${this.websiteId}/booster/cloudflare`]);
      this._activeModal.close();
    }
    else {
      this.showVerify = true;
      this.resize([null, 700]);
    }
  }

  public copiedNameServer(index: number) {
    this.isCopiedCodes[index] = true;
  }

  public copiedHostName(index: number) {
    this.isCopiedHostNames[index] = true;
  }

  public copiedAHostName(index: number) {
    this.isCopiedAHostNames[index] = true;
  }

  public sendEvent(category: string, action: string): void {
    const analyticsData = {
      eventName: category,
      eventAction: action,
      eventLabel: 'Cloudflare',
      websiteId: this.websiteId
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
